import srcConfig from "@/configs/index.js";
import createComponentImport from "../createComponent.js";

/**
 * 
 */
Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, // 月份
        "d+": this.getDate(), // 日
        "h+": this.getHours(), // 小时
        "m+": this.getMinutes(), // 分
        "s+": this.getSeconds(), // 秒
        "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
        "S": this.getMilliseconds() // 毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ?
                (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}

//
Date.prototype.getWeek = function () {
    let str = "";

    //
    let week = this.getDay();

    //
    if (week == 0) {
        str = "星期日";
    } else if (week == 1) {
        str = "星期一";
    } else if (week == 2) {
        str = "星期二";
    } else if (week == 3) {
        str = "星期三";
    } else if (week == 4) {
        str = "星期四";
    } else if (week == 5) {
        str = "星期五";
    } else if (week == 6) {
        str = "星期六";
    }

    //
    return str;
}


/**
 * 
 */
function urlLocate(url) {
    if (url == null || url.length == 0)
    {
        this.Toast("未指定跳转地址");
    }
    else if(url == '#')
    {
        return;
    }
    else
    {
        window.location.href = url;
    }
}

function getImgUrl(path) {
    if (path.indexOf("https://") == 0 || path.indexOf("http://") == 0)
    {
        return path;
    }
    else
    {
        return `${this.getShopTopDomainUrl()}${path}`;
    }
}

function createComponent(Component, props) {
    return createComponentImport(Component, props);
}

function consoleInfo(msg) {
    console.info(msg);
}

function getPriceTypeName(priceType) {
    switch (priceType) {
        case 1: {
            return "特价商品";
        }
        case 2: {
            return ""
        }
        case 3: {
            return ""
        }
    }
}

function getFullUrlWithoutHash()
{
    return `${window.location.protocol}//${window.location.host}${window.location.pathname}`
}

function getFullUrlWithHash() {
    return `${window.location.protocol}//${window.location.host}${window.location.pathname}${window.location.hash}`
}

/**
 * 
 */
function getDigitalCardHostUrl() {
    return 'https://digitcard.ziubao.com/'
}

function getZiubaoTopDomainUrl()
{
    return 'https://zyb.ziubao.com/'
}

function getShopTopDomainUrl() {
    //
    return 'https://shop.ziubao.com/';
}

function getShopHostUrl()
{
    //
    let fullUrl;

    //
    if (process.env.ziubao_shop_platform == 'ziubao') {
        fullUrl = "https://shop.ziubao.com/yingqiyuPro/ziubaoShopInner/"
    }
    else if(process.env.ziubao_shop_platform == 'ziubao_test')
    {
        fullUrl = `${getShopTopDomainUrl()}yingqiyu-test/`
    }

    //
    return fullUrl;
}

/**
 * 
 */
function getShopStaticResouceUrl() {
    //
    return `${getShopHostUrl()}static_resource/`;
}

function getShopFoodMarketHostUrl()
{
    //
    let fullUrl;

    //
    if (process.env.ziubao_shop_platform == 'ziubao') {
        fullUrl = `${getShopHostUrl()}nianhuo_static/`
    }
    else if(process.env.ziubao_shop_platform == 'ziubao_test')
    {
        fullUrl = `${getShopHostUrl()}main_food_market/`
    }

    //
    return fullUrl;
}

function getShopMainHostUrl()
{
    if (process.env.ziubao_shop_platform == 'ziubao') {
        return 'https://shop.ziubao.com/main_static';
    }
    else if (process.env.ziubao_shop_platform == 'yszs')
    {
        return `${getShopHostUrl()}main_static/`
    }


    //
    let fullUrl;

    //
    if (process.env.ziubao_shop_platform == 'ziubao') {
        fullUrl = `${getShopHostUrl()}main_static/`
    }
    else if(process.env.ziubao_shop_platform == 'ziubao_test')
    {
        fullUrl = `${getShopHostUrl()}main_index/`
    }

    //
    return fullUrl;
}

function getShopSuperMarketHostUrl()
{
    //
    let fullUrl;

    //
    if (process.env.ziubao_shop_platform == 'ziubao') {
        fullUrl = `${getShopHostUrl()}mall_static/`
    }
    else if(process.env.ziubao_shop_platform == 'ziubao_test')
    {
        fullUrl = `${getShopHostUrl()}main_supermarket/`
    }

    //
    return fullUrl;
}

function goHomePage() {
    //
    if (process.env.ziubao_shop_platform == 'ziubao') {
        window.location.href = `${getShopHostUrl()}main_static`
    }
    else if (process.env.ziubao_shop_platform == 'ziubao_test') {
        window.location.href = `${getShopHostUrl()}main_index/`
    }
}

/**
 * 
 */
function getShopInstructionHostUrl() {
    //
    return `${getShopHostUrl()}shop_instruction/`;
}

function goToAuroraChat() {
    window.location.href = `${getShopHostUrl()}main_chat/#/`
}

/**
 * 
 */
function checkLocalStorage() {
    // localStorage.clear();
}

function jumpToModule(url, router, subUrl, hostType, funcName, jumpType) {
    if (funcName)
    {
        return this[funcName]();
    }
    if (url && url.length > 0) {
        if (jumpType == 'replace')
        {
            window.location.replace(url);
        }
        else
        {
            window.location.href = url;
        }
    } else if (router) {
        if (jumpType == 'replace') {
            this.$router.replace({
                path: router,
            })
        }
        else {
            this.$router.push({
                path: router,
            })
        }
    } else if (hostType) {
        if (hostType == 'food_market') {
            window.location.href = `${getShopFoodMarketHostUrl()}${subUrl}`
        }
        else if (hostType == 'supermarket') {
            window.location.href = `${getShopSuperMarketHostUrl()}${subUrl}`
        }
        else if (hostType == 'main') {
            window.location.href = `${getShopMainHostUrl()}${subUrl}`
        }
    } else {
        this.Toast("未开放");
    }
}

//
function stringToDate(dateString)
{
    const result = /(\d+)-(\d+)-(\d+) (\d+):(\d+):(\d+)/g.exec(dateString)

    if(result.length < 7)
    {
        throw exception('invalid date string')
    }

    return new Date(parseInt(result[1]), parseInt(result[2] - 1), parseInt(result[3]), parseInt(result[4]), parseInt(result[5]), parseInt(result[6]))
}

function goToAuroraChatMessageDetail(
    conversationTargetUsername,
    conversationTargetNickname,
    conversationTargetAvatarUrl,
) {
    //
    let query = `conversationTargetUsername=${conversationTargetUsername}&conversationTargetNickname=${conversationTargetNickname ? encodeURIComponent(conversationTargetNickname) : ""}&conversationTargetAvatarUrl=${conversationTargetAvatarUrl ? encodeURIComponent(conversationTargetAvatarUrl) : ""}`

    //
    window.location.href = `${getShopHostUrl()}main_chat/#/chatDetail?${query}`
}

export {
    urlLocate,
    getImgUrl,
    createComponent,
    consoleInfo,
    getPriceTypeName,
    getFullUrlWithoutHash,
    getFullUrlWithHash,
    getShopStaticResouceUrl,
    getShopHostUrl,
    getShopFoodMarketHostUrl,
    getShopMainHostUrl,
    getShopSuperMarketHostUrl,
    getShopInstructionHostUrl,
    getDigitalCardHostUrl,
    getZiubaoTopDomainUrl,
    getShopTopDomainUrl,
    goHomePage,
    checkLocalStorage,
    goToAuroraChat,
    jumpToModule,
    stringToDate,
    goToAuroraChatMessageDetail,
}

export default {
    urlLocate,
    getImgUrl,
    createComponent,
    consoleInfo,
    getPriceTypeName,
    getFullUrlWithoutHash,
    getFullUrlWithHash,
    getShopStaticResouceUrl,
    getShopHostUrl,
    getShopFoodMarketHostUrl,
    getShopMainHostUrl,
    getShopSuperMarketHostUrl,
    getShopInstructionHostUrl,
    getDigitalCardHostUrl,
    getZiubaoTopDomainUrl,
    getShopTopDomainUrl,
    goHomePage,
    checkLocalStorage,
    goToAuroraChat,
    jumpToModule,
    stringToDate,
    goToAuroraChatMessageDetail,
}